import React, { useRef, useState } from 'react';

import { useAppStore } from '../../store/useAppStore';
import { useTranslations } from '../../hooks/useTranslations';

const History = () => {
  const {
    // Session
    removeFromHistory,
    renameHistoryItem,
    imageHistory,
    setCurrentImage,
    currentImage,
  } = useAppStore();

  const { t } = useTranslations();
  const fileInputRef = useRef(null);

  const galleryScrollRef = useRef(null);

  // Gallery functions
  const scrollGalleryLeft = () => {
    if (galleryScrollRef.current) {
      galleryScrollRef.current.scrollBy({ left: -200, behavior: 'smooth' });
    }
  };

  const scrollGalleryRight = () => {
    if (galleryScrollRef.current) {
      galleryScrollRef.current.scrollBy({ left: 200, behavior: 'smooth' });
    }
  };

  return (
    <div className="image-gallery">
      <div className="gallery-container">
        <button className="gallery-nav gallery-nav-left" onClick={scrollGalleryLeft}>
          <i className="fas fa-chevron-left"></i>
        </button>
        <div className="gallery-scroll" ref={galleryScrollRef}>

            {/* Pinned first, then rest */}
            {[...imageHistory.map((v,i)=>({ ...v, __i:i }))]
              .sort((a,b)=> (b.pinned===true) - (a.pinned===true) || a.__i - b.__i)
              .map((itemWrap) => {
                const item = itemWrap
                const index = itemWrap.__i
                return (
            <div 
              key={index} 
              className={`gallery-item history-card ${item.pinned ? 'pinned' : ''} ${currentImage === item.image ? 'active' : ''}`}
              onClick={() => setCurrentImage(item.image)}
            >
              {/* Card Header with Controls */}
              <div className="card-header" onClick={(e) => e.stopPropagation()}>
                <button 
                  className="card-btn remove-btn" 
                  title="Remove from history"
                  onClick={() => {
                    removeFromHistory(index)
                  }}
                >
                  <i className="fas fa-times"></i>
                </button>
                <button 
                  className={`card-btn pin-btn ${item.pinned ? 'pinned' : ''}`}
                  title={item.pinned ? 'Unpin' : 'Pin as current version'}
                  onClick={() => {
                    togglePin(index)
                    if (!item.pinned) setCurrentImage(item.image)
                  }}
                >
                  <i className={item.pinned ? 'fas fa-star' : 'far fa-star'}></i>
                </button>
              </div>

              {/* Image Container */}
              <div className="card-image">
                <img src={item.image} alt={item.title || item.description || `Edit ${index + 1}`} loading="lazy" />
                {item.pinned && (
                  <div className="pinned-badge">
                    <i className="fas fa-star"></i>
                  </div>
                )}
              </div>

              {/* Card Footer with Operation Name and Controls */}
              <div className="card-footer">
                <div className="card-content">
                  <div className="card-title" title={item.title || item.description}>
                    {(item.title || item.description || `Edit ${index + 1}`).slice(0, 20)}
                  </div>
                </div>
                <div className="card-actions">
                  <button 
                    className="card-btn edit-btn"
                    title="Rename"
                    onClick={(e) => {
                      e.stopPropagation()
                      const t = prompt('Rename this edit:', item.title || item.description || '')
                      if (t !== null && t.trim()) renameHistoryItem(index, t.trim())
                    }}
                  >
                    <i className="fas fa-pen"></i>
                  </button>
                </div>
              </div>
            </div>
            )})}
        </div>
        <button className="gallery-nav gallery-nav-right" onClick={scrollGalleryRight}>
          <i className="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>
  );
};

export default History; 